import axios from 'axios';
import { baseUrl } from '@/config';
import { downloadFile } from '@/utils/file';

const PREFIX_URL = '/event/trouble-shooting';
export default {

  /**
   * 선택한 이벤트들에 대해 장애티켓을 발행한다.
   * @return {[type]} [description]
   */
  setTroubleShooting(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/add-trouble-shooting.do`, params);
  },
  /**
   * 장애 티켓 상세 정보를 조회한다.
   * @author Ju
   * @param  {Object} params [description]
   * @return {Object} data에 {troubleShootingInfo, eventList, troubleShootingHist, relationKedbList} 객체 전달
   */
  getTroubleShootingDetailInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-trouble-shooting-detail-info.do`, params);
  },
  /**
   * 장태 티켓의 이벤트 정보를 조회한다.
   * @author Ju
   * @param  {Number} troubleTicketGroupId
   * @return {[type]}
   */
  getTroubleShootingTargeEventList(troubleTicketGroupId) {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-trouble-shooting-event-list.do`, { params: { troubleTicketGroupId } });
  },
  /**
   * 장애 티켓 이벤트의 상태 변경 이력 정보를 조회한다.
   * @author Ju
   * @param  {Object} param { troubleTicketGroupId, managetypeId, rsctypeId, rscId, rscKey }
   * @return {[type]}       [description]
   */
  getTroubleShootingTargeEventHistList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-trouble-shooting-event-hist-list.do`, params);
  },
  /**
   * [장애티켓 파일업로드 & 의견 등록]
   */
  addTroubleShootingHist(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/add-trouble-shooting-hist.do`, params);
  },
  /**
   * [장애티켓 처리 이력 조회]
   */
  getTroubleShootingHistInfo(troubleTicketGroupId) {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-trouble-shooting-hist.do`, { params: { troubleTicketGroupId } });
  },
  /**
   * [장애티켓 처리 이력 삭제 + 파일정보 삭제]
   */
  deleteTroubleShootingHist(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/delete-trouble-shooting-hist.do`, params);
  },
  /**
   *  [장애티켓 보고서 등록]
   */
  completeTroubleShooting(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/complete-trouble-shooting.do`, params);
  },
  /**
   * [장애티켓] 발행된 장애티켓 정보를 조회한다.
   */
  getTroubleShootingList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-trouble-shooting-list.do`, params);
  },
  /**
   * [장애티켓] 처리이력 첨부파일 다운로드한다.
   */
  downloadAttachFile(params) {
    downloadFile(`${baseUrl}${PREFIX_URL}/download-file.do`, params, 'POST');
  },
  /**
   * [장애티켓] 확인자 업데이트
   */
  setConfirmManagerId(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-confirm-manager.do`, params);
  },
  /**
   * 장애티켓 엑셀명을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getTroubleShootingExcel(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-trouble-shooting-excel-name.do`, params);
  },
  /**
   * 선택한 장애티켓을 삭제한다.
   * @author yelim
   */
  deleteTroubleShootingList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/delete-trouble-shooting-list.do`, params);
  },
  setRelationKedbInTroubleTicket(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-relation-kedb-in-trouble-ticket.do`, params);
  },
  getRelationKedbInTroubleTicket(troubleTicketGroupId) {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-relation-kedb-in-trouble-ticket.do`, { params: { troubleTicketGroupId } });
  },
  deleteRelationKedbInTroubleTicket(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/delete-relation-kedb-in-trouble-ticket.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/event/trouble-shooting.js